import { lazy } from 'react';
import { authRoles } from 'app/auth';

import DashboardLayout from './layouts/DashboardLayout';

const DashboardOverviewView = lazy(() => import('./use-cases/DashboardOverview'));
const DashboardPrescriptionsView = lazy(() => import('./use-cases/DashboardPrescriptions'));
const DashboardServicesView = lazy(() => import('./use-cases/DashboardServices'));
const DashboardCompetitorComparisonView = lazy(() =>
  import('./use-cases/DashboardCompetitorComparison')
);

const DashboardConfig = {
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
        healtheraHeader: {
          display: true,
          options: {
            organisationSelector: true,
            pharmacySelector: false,
          },
        },
      },
    },
  },
  auth: authRoles.pharmacist,
  routes: [
    {
      path: 'dashboard',
      element: (
        <DashboardLayout>
          <DashboardOverviewView />
        </DashboardLayout>
      ),
    },
    {
      path: 'dashboard/overview',
      element: (
        <DashboardLayout>
          <DashboardOverviewView />
        </DashboardLayout>
      ),
    },
    {
      path: 'dashboard/prescriptions',
      element: (
        <DashboardLayout>
          <DashboardPrescriptionsView />
        </DashboardLayout>
      ),
    },
    {
      path: 'dashboard/services',
      element: (
        <DashboardLayout>
          <DashboardServicesView />
        </DashboardLayout>
      ),
    },
    {
      path: 'dashboard/competitor-comparison',
      element: (
        <DashboardLayout>
          <DashboardCompetitorComparisonView />
        </DashboardLayout>
      ),
    },
  ],
};

export default DashboardConfig;
